import api from 'config/api';
import axios from 'axios';
import { getHeader, getAxiosUrl } from 'helpers';

const headers = getHeader();

export const getUserData = async () => {
    try {
        const url = getAxiosUrl(api.path.customer);
        const response = await axios.get(url, { headers });
        return response.data;
    } catch (error) {
        return null;
    }
};

export const saveUserData = async (userData) => {
    try {
        const url = getAxiosUrl(api.path.customer);
        const response = await axios.put(url, userData, { headers });

        return { ...response.data, user: userData };
    } catch (error) {
        return error;
    }
};

export const saveSubscribe = async (payload) => {
    const __data = {
        [payload[0].name]: payload[0].checked
    }
    console.log(__data, payload)
    try {
        const url = getAxiosUrl(api.path.customer);
        const response = await axios.put(url, __data, { headers });
        return { ...response.data };
    } catch (error) {
        return null;
    }
};

export const setNewPassword = async (passwords) => {
    try {
        const url = getAxiosUrl(api.path.customer);
        const response = await axios.put(url, passwords, { headers });
        return response.data;
    } catch (error) {
        return error;
    }
};
